import { Printer, CreatePrinterPayload } from '../types/printers.types';
import { AppError } from './classes';
import { getPrivateApi } from '../lib/axiosConfig';

// O endpoint real será: "/printers"
const endpoint = '/printers';
const api = getPrivateApi();

const generateId = () => Math.random().toString(36).substr(2, 9);

export const getPrinters = async (): Promise<Printer[]> => {
    try {
        const { data } = await api.get<any>(`${endpoint}`);
        const content = data?.content ?? data;
        return Array.isArray(content) ? content : [];
    } catch (error: any) {
        const errMsg = 'Erro ao buscar impressoras!';
        console.error(errMsg, error?.response ?? error);
        const message = error?.response?.data?.message ?? errMsg;
        throw new AppError(message, error.status);
    }
};

export const createPrinter = async (payload: CreatePrinterPayload): Promise<Printer> => {
    try {
        const { data: response } = await api.post<Printer>(`${endpoint}`, payload);
        return response;
    } catch (error: any) {
        const errMsg = 'Erro ao criar impressora!';
        console.error(errMsg, error?.response ?? error);
        const message = error?.response?.data?.message ?? errMsg;
        throw new AppError(message, error.status);
    }
};

export const deletePrinter = async (id: string): Promise<void> => {
    try {
        await api.delete(`${endpoint}/${id}`);
    } catch (error: any) {
        const errMsg = 'Erro ao remover impressora!';
        console.error(errMsg, error?.response ?? error);
        const message = error?.response?.data?.message ?? errMsg;
        throw new AppError(message, error.status);
    }
};
